import Rest from '../Rest'

export default class ContactListService extends Rest {
  /**
   * @type {String}
   */
  static resource = '/api/v1/contact'

  static build(vs: any = null) {
    return new this(this.resource, null, vs)
  }
}
